const encryption = {
    key: '7196322b4f7b0ce2971a2bf95cf520c1',
    iv: '/(?&ZdemqHl,ifE0'
};

export default encryption;